var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 231,
    viewBox: "0 0 214 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M161.824 230.719H48.3566C63.2725 220.153 85.6464 199.022 48.3566 206.48C1.74435 215.803 20.3344 163.324 20.3344 152.144C20.3344 149.5 14.2653 149.974 3.554 144.686C-11.0001 137.5 32.4998 114.5 28.38 72.2369C24.2848 30.2264 94.914 -17.2586 162.357 8.04508C276.302 50.796 166.885 164.396 161.824 230.719Z",
    fill: "url(#paint0_linear_18_47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9",
    filter: "url(#filter0_i_18_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 145.255,
    cy: 74.9005,
    r: 60.9955,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 145.522,
    cy: 75.1669,
    r: 55.9347,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12",
    filter: "url(#filter1_i_18_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.522,
    cy: 75.1668,
    r: 42.0842,
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 145.522,
    cy: 75.1669,
    r: 24.5047,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10",
    filter: "url(#filter2_i_18_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.522,
    cy: 75.1669,
    r: 9.0561,
    fill: "#FF0000"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18_47",
    x: 84.2598,
    y: 2.00508,
    width: 121.991,
    height: 133.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_47"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18_47",
    x: 103.438,
    y: 33.0826,
    width: 84.1685,
    height: 88.1684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_47"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_18_47",
    x: 136.466,
    y: 66.1108,
    width: 18.1123,
    height: 22.1122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_47",
    x1: 106.744,
    y1: 0.960442,
    x2: 106.744,
    y2: 230.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738198"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon 6.e805e4ef95b524faf12318f671b1819a.svg";
export { ForwardRef as ReactComponent };